import { Texto } from '@gravitate-js/excalibrr'
import { Flex } from 'antd'
import type { HTMLAttributes, ReactNode } from 'react'

type InfoCellRendererProps = {
  title?: ReactNode
  action?: ReactNode
  subtitle?: ReactNode
  tag?: ReactNode
} & Omit<HTMLAttributes<HTMLElement>, 'title' | 'tag'>

export function InfoCellRenderer({ title, action, subtitle, tag, ...props }: InfoCellRendererProps) {
  return (
    <Flex
      {...props}
      role='button'
      vertical
      justify='center'
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--bg-2)',
        cursor: 'pointer',
      }}
      className='py-1 px-2'
    >
      <Flex align='center' justify='space-between' gap={6}>
        <Texto category='p2' className='text-truncate'>
          {title}
        </Texto>
        {action}
      </Flex>
      <Flex align='center' justify='space-between' gap={6}>
        <Texto
          appearance='hint'
          style={{ flex: '0 1 auto', display: 'flex', overflow: 'hidden', textOverflow: 'clip' }}
        >
          {subtitle}
        </Texto>
        {tag}
      </Flex>
    </Flex>
  )
}
